import { NAMESPACE } from './reducer';
import { State } from './types';

type GlobalState = {
    [key in typeof NAMESPACE]: State;
};

export const getCart = (state: GlobalState) => state[NAMESPACE].cart;

export const getRecoveredCart = (state: GlobalState) => state[NAMESPACE].recoveredCart;

export const getCartLoading = (state: GlobalState) => state[NAMESPACE].isLoading;
